import { combineReducers } from "redux";
import { localeReducer } from "react-localize-redux";
import profileReducer from "./profileReducer";
import appSettingReducer from "./appSettingReducer";
import authReducer from "./authReducer";
import navigationReducer from "./navigationReducer";
import loadingReducer from "./loadingReducer";
import errorReducer from "./errorReducer";
import jobReducer from "./jobReducer";
import testsReducer from "./testsReducer";
import resultReducer from "./resultReducer";
import passwordresetReducer from "./passwordresetReducer";
import userReducer from "./userReducer";
import customerReducer from "./customerReducer";
import blobReducer from "./blobReducer";
import settingReducer from "./settingReducer";
import deviceReducer from "./deviceReducer";
import reportReducer from "./reportReducer";
import resetReducer from "./resetReducer";
import languageReducer from "./languageReducer";
import subtestReducer from "./subtestReducer";
import treeviewReducer from "./treeviewReducer";
import deviceRepositoryReducer from "./deviceRepositoryReducer";
import deviceSoftwareReducer from "./deviceSoftwareReducer";
import mfaReducer from "./mfaReducer";

const appReducer = combineReducers({
  localeReducer,
  profileReducer,
  appSettingReducer,
  authReducer,
  navigationReducer,
  loadingReducer,
  errorReducer,
  jobReducer,
  testsReducer,
  resultReducer,
  passwordresetReducer,
  userReducer,
  customerReducer,
  blobReducer,
  settingReducer,
  deviceReducer,
  reportReducer,
  resetReducer,
  languageReducer,
  subtestReducer,
  treeviewReducer,
  deviceRepositoryReducer,
  deviceSoftwareReducer,
  mfaReducer
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js